import React from 'react';
import ComparisonTable from './ComparisonTable';
import EnterpriseAdvantageShowcase from './EnterpriseAdvantageShowcase';

const WhyUfficientPage = () => {
  return (
    <div>
      <ComparisonTable />
      <EnterpriseAdvantageShowcase />
    </div>
  );
};

export default WhyUfficientPage; 